import React, { useEffect, useState } from "react";

const Overlay: React.FC = () => {
  const [isPortrait, setIsPortrait] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  const updateState = () => {
    const portrait = window.matchMedia("(orientation: portrait)").matches;
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
    const screenWidth = window.innerWidth;
    setIsPortrait(portrait);
    setIsMobileOrTablet(isTouchDevice || screenWidth <= 1024);
  };

  useEffect(() => {
    updateState();
    window.addEventListener("orientationchange", updateState);
    window.addEventListener("resize", updateState);
    return () => {
      window.removeEventListener("orientationchange", updateState);
      window.removeEventListener("resize", updateState);
    };
  }, []);

  if (!isPortrait || !isMobileOrTablet) return null;

  return (
    <div style={overlayStyle}>
      <div style={contentStyle}>
        <div className="icons">
          {/* iPad-like animation */}
          <svg
            width="150"
            height="150"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="ipad"
          >
            <rect x="7" y="2" width="10" height="20" rx="2" ry="2" />
            <line x1="12" y1="18" x2="12" y2="18" />
          </svg>

          {/* desktop icon */}
          <svg
            width="150"
            height="150"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="desktop"
          >
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
        </div>

        <p style={textStyle}>
          For the best experience,<br />
          switch to a <strong>desktop</strong> or please use your device in <strong>landscape mode</strong>.
        </p>
      </div>

      <style>
        {`
          .icons {
            display: flex;
            gap: 3rem;
            align-items: center;
            justify-content: center;
          }

          .ipad {
            animation: tiltTablet 2.5s infinite ease-in-out;
            transform-origin: center center;
          }

          .desktop {
            opacity: 0;
            animation: fadeInDesktop 4s infinite ease-in-out;
          }

          @keyframes tiltTablet {
            0%   { transform: rotate(0deg) scale(1); }
            25%  { transform: rotate(-20deg) scale(1.05); }
            50%  { transform: rotate(0deg) scale(1); }
            75%  { transform: rotate(20deg) scale(1.05); }
            100% { transform: rotate(0deg) scale(1); }
          }

          @keyframes fadeInDesktop {
            0%   { opacity: 0; transform: translateY(10px); }
            30%  { opacity: 0.6; transform: translateY(0); }
            60%  { opacity: 1; transform: translateY(-5px); }
            100% { opacity: 0; transform: translateY(10px); }
          }
        `}
      </style>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 1)",
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
  flexDirection: "column",
  padding: "2rem",
};

const contentStyle: React.CSSProperties = {
  textAlign: "center",
};

const textStyle: React.CSSProperties = {
  marginTop: "2rem",
  fontSize: "1.5rem",
  fontWeight: 400,
  lineHeight: 1.5,
  maxWidth: "90vw",
};

export default Overlay;
